<template>
  <modal
    width="initial"
    :can-be-dismissed="false"
    ref="orderPlacedModal"
    :full-screen="isMobile()"
    :borderless="isMobile()"
  >
    <template slot="header">
      <div class="order-type-header">
        <span>Table {{ getTableNumber }}</span>
      </div>
    </template>
    <template slot="body">
      <div class="progress-container payment-indicator">
        <div
          :class="showNewUi ? 'new-payment-indicator' : 'payment-indicator'"
          :style="indicatorStyles"
          id="payment-indicator"
        >
          <span class="payment-indicator-text" :style="textStyles">
            {{ this.$t("message.orderPlaced").concat('.') }}
          </span>
          <span
            class="payment-indicator-sub-text mt-3"
            v-if="showNewUi"
            style="font-size: 0.9rem; font-weight: 300"
          >
            {{ this.$t("message.orderPlaced").concat('.') }}
          </span>
        </div>
      </div>
    </template>
    <template slot="footer" class="bg-body">
      <div style="margin-top: 12rem">
        <poweredby />
      </div>
      </template>
  </modal>
</template>

<script>
import modal from '../modal.vue';
import poweredby from '../shared/poweredby.vue';
export default {
  name: 'EnterName',
  components: {
    modal,
    poweredby
  },
  data() {
    return {
      name: '',
      error: false
    }
  },
  computed: {
    indicatorStyles() {
      return {
        backgroundImage: `url(${require("../../assets/indicators/payment-success-circle.svg")}), url(${require("../../assets/indicators/payment-success-tick.svg")})`,
        backgroundPosition: "center 25px, center 72px",
        paddingTop : this.showNewUi? "10px" : "",
      };
    },
    textStyles() {
      let color = "#00A806";
      let flex = "100% 1 0";
      let marginTop = "13rem";

      if (this.showNewUi) {
        flex = "15% 1 0"
        marginTop = this.isPending || this.succeeded ? "13rem" : "1rem";
        return {
          flex,
          marginTop,
          fontWeight: 300,
          textAlign: "center",
        };
      }
      return { color, flex: "100% 1 0" };
    },
    getTableNumber() {
      return sessionStorage.getItem('table');
    },
    showNewUi() {
      // temporarily return false for show new UI
      return false;
    }
  },

}
</script>

<style>

</style>